import { useLocation } from 'react-router-dom';

const useNavigationMethods = () => {
  const location = useLocation();

  const isNavItemActive = (itemPath: string) => {
    const currentPath = location.pathname;
    return currentPath === itemPath;
  };

  // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
  const isDropdownActive = ({ dropdownItems, dropdownSecondaryItems }) => {
    const currentPath = location.pathname;
    // check if currentPath is in dropdownItems and dropdownSecondaryItems
    const isDropdownItem = dropdownItems.some(
      // @ts-expect-error TS7006 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      (item) => item.path === currentPath,
    );
    const isDropdownSecondaryItem = dropdownSecondaryItems?.some(
      // @ts-expect-error TS7006 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      (item) => item.path === currentPath,
    );

    return isDropdownItem || isDropdownSecondaryItem;
  };

  return { isNavItemActive, isDropdownActive };
};

export default useNavigationMethods;
